import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import PasswordChecker from '../../../components/ui/PasswordChecker'

import DashboardLayout from '../../../components/ui/DashboardLayout'
import { LoaderIcon } from '../../../components/ui/Swicons'
import { devURL } from '../../../utils'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'

export default function ChangePassword() {
  const token = localStorage.getItem('swToken')
  const { register, handleSubmit, reset } = useForm()
  const [loader, isLoading] = useState(false)
  const [isDisabledLogin, setDisabledLogin] = useState(true)
  const [showOldPassword, setShowOldPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [email, setEmail] = useState('')
  const [passwordCorrections, setPasswordCorrections] = useState({
    isLength: false,
    isUpper: false,
    isLower: false,
    isSymbol: false,
  })
  const initialValues = {
    oldpassword: '',
    newpassword: '',
    confirmpassword: '',
  }
  const [formValues, setFormValues] = useState(initialValues)
  const [showPasswordChecker, setShowPasswordChecker] = useState(false)

  useEffect(() => {
    getUserProfileData()
  }, [])

  useEffect(() => {
    reset(formValues)
  }, [formValues])

  const getUserProfileData = () => {
    axios
      .get(`${devURL}/user/get-user-info`, {
        headers: { token: token },
      })
      .then((res) => {
        console.log(res.data)
        setEmail(res.data.email)
      })
  }

  const passwordVerify = (e) => {
    const lower = /(?=.*[a-z])/
    const upper = /(?=.*[A-Z])/
    const length = /(?=.{8,})/
    const symbol = /(?=.*[!@#$%^&*])/
    let pass = e.target.value
    if (pass.match(lower))
      setPasswordCorrections((val) => ({ ...val, isLower: true }))
    else setPasswordCorrections((val) => ({ ...val, isLower: false }))
    if (pass.match(upper))
      setPasswordCorrections((val) => ({ ...val, isUpper: true }))
    else setPasswordCorrections((val) => ({ ...val, isUpper: false }))
    if (pass.match(length))
      setPasswordCorrections((val) => ({ ...val, isLength: true }))
    else setPasswordCorrections((val) => ({ ...val, isLength: false }))
    if (pass.match(symbol))
      setPasswordCorrections((val) => ({ ...val, isSymbol: true }))
    else setPasswordCorrections((val) => ({ ...val, isSymbol: false }))
  }

  const handleChange = (e) => {
    if (e.target.name === 'oldpassword' && e.target.value.length >= 0) {
      formValues.oldpassword = e.target.value
    } else if (e.target.name === 'newpassword' && e.target.value.length >= 0) {
      formValues.newpassword = e.target.value
    } else if (
      e.target.name === 'confirmpassword' &&
      e.target.value.length >= 0
    ) {
      formValues.confirmpassword = e.target.value
    }
    if (
      formValues.oldpassword !== '' &&
      formValues.newpassword !== '' &&
      formValues.confirmpassword !== ''
    )
      setDisabledLogin(false)
    else setDisabledLogin(true)
  }
  const onSubmit = (val) => {
    isLoading(true)
    var passwordformat =
      /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\!\@\#\$\%\^\&\*\(\)\_\+\.\,\;\:\-]).{8,}/
    if (val.oldpassword === '') {
      toast.error('Please enter old password.')
      isLoading(false)
    } else if (val.newpassword === '') {
      toast.error('Please enter your new password.')
      isLoading(false)
    } else if (val.newpassword === val.oldpassword) {
      toast.error('Your new password cannot be same as old password.')
      isLoading(false)
    } else if (val.newpassword.length < 8) {
      toast.error('Password should be atleast 8 character.')
      isLoading(false)
    } else if (!val.newpassword.match(passwordformat)) {
      toast.error(
        'Password should be must contain at least one number and one uppercase and lowercase letter with at least one special character!.'
      )
      isLoading(false)
    } else if (val.confirmpassword === '') {
      toast.error('Please confirm your password.')
      isLoading(false)
    } else if (val.newpassword !== val.confirmpassword) {
      toast.error('Your entered password is mismatch.')
      isLoading(false)
    } else {
      axios
        .post(
          `${devURL}/user/update-password`,
          { old_password: val.oldpassword, new_password: val.newpassword },
          { headers: { token: token } }
        )
        .then((response) => {
          isLoading(true)
          if (response.data.status) {
            isLoading(false)
            setFormValues(initialValues)
            setDisabledLogin(true)
            Swal.fire({
              icon: 'success',
              text: `Entered ${response.data.message}`,
              confirmButtonText: 'Ok',
            })
          } else {
            isLoading(false)
            Swal.fire(`Incorrect Old Password `)
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.errorMessage
          ) {
            isLoading(false)
            //Swal.fire(`Old Password is ${error.response.data.errorMessage}`);
            toast.error(`Old Password is incorrect`)
          }
        })
    }
  }

  const handleForgotPassword = () => {
    axios
      .get(`${devURL}/user/forgot-password?email=` + email)
      .then((res) => {
        if (res.data.status) {
          isLoading(false)
          toast.success(res.data.message)
        } else {
          isLoading(false)
          toast.error(`Incorrect email address`)
        }
      })
      .catch((err) => {
        isLoading(false)
        if (
          err.response &&
          err.response.data &&
          err.response.data.errorMessage
        ) {
          toast.error(err.response.data.errorMessage)
        }
      })
  }
  return (
    <DashboardLayout>
      <div className='page-title text-xl font-bold'>
        <p>Change Password</p>
      </div>
      <div className='sw-add-recipient-form mt-6'>
        <form onSubmit={handleSubmit(onSubmit)} className='lg:w-1/2'>
          <div className='mb-6'>
            <label
              htmlFor='recipient_name'
              className='text-gray-600 text-sm text-left font-bold mb-1'
            >
              Old Password<span style={{ color: 'red' }}>*</span>
            </label>
            <div className='relative flex items-center'>
              <input
                {...register('oldpassword')}
                type={showOldPassword ? 'text' : 'password'}
                name='oldpassword'
                value={register.oldpassword}
                onChange={handleChange}
                className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                placeholder='Enter old password'
              />
              <button
                className='absolute left-full -translate-x-full p-2 z-20'
                onClick={(e) => {
                  e.preventDefault()
                  setShowOldPassword((val) => !val)
                }}
              >
                {!showOldPassword ? (
                  <AiOutlineEye size='1.2rem' />
                ) : (
                  <AiOutlineEyeInvisible size='1.2rem' />
                )}
              </button>
            </div>
          </div>
          <div className='mb-6 relative'>
            <label
              htmlFor='recipient_nick_name'
              className='text-gray-600 text-sm text-left font-bold mb-1'
            >
              New Password<span style={{ color: 'red' }}>*</span>
            </label>
            <div className='relative flex items-center'>
              <input
                {...register('newpassword')}
                name='newpassword'
                onChange={(e) => {
                  handleChange(e)
                  passwordVerify(e)
                }}
                type={showNewPassword ? 'text' : 'password'}
                value={register.newpassword}
                className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                placeholder='Enter new password'
                onFocus={() => {
                  setShowPasswordChecker(true)
                }}
                onBlurCapture={() => setShowPasswordChecker(false)}
              />
              <button
                className='absolute left-full -translate-x-full p-2 z-20'
                onClick={(e) => {
                  e.preventDefault()
                  setShowNewPassword((val) => !val)
                }}
              >
                {!showNewPassword ? (
                  <AiOutlineEye size='1.2rem' />
                ) : (
                  <AiOutlineEyeInvisible size='1.2rem' />
                )}
              </button>
            </div>
            <div
              className={`absolute w-max z-10 inset-x-full top-1/3 p-1 rounded bg-slate-50 drop-shadow-lg ml-4 ${
                showPasswordChecker ? 'block' : 'hidden'
              }`}
            >
              <PasswordChecker {...passwordCorrections} />
            </div>
          </div>
          <div className='mb-6'>
            <label
              htmlFor='bank_account_number'
              className='text-gray-600 text-sm text-left font-bold mb-1'
            >
              New Confirm Password<span style={{ color: 'red' }}>*</span>
            </label>
            <div className='relative flex items-center'>
              <input
                {...register('confirmpassword')}
                name='confirmpassword'
                onChange={handleChange}
                type={showConfirmPassword ? 'text' : 'password'}
                value={register.confirmpassword}
                className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                placeholder='Enter Confirm Password'
              />
              <button
                className='absolute left-full -translate-x-full p-2 z-20'
                onClick={(e) => {
                  e.preventDefault()
                  setShowConfirmPassword((val) => !val)
                }}
              >
                {!showConfirmPassword ? (
                  <AiOutlineEye size='1.2rem' />
                ) : (
                  <AiOutlineEyeInvisible size='1.2rem' />
                )}
              </button>
            </div>
          </div>
          <div className='mb-6'>
            <button
              type='submit'
              className='group relative py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
              // style={{ backgroundColor: "#246eaa" }}
              style={
                !isDisabledLogin
                  ? { backgroundColor: '#246eaa' }
                  : { backgroundColor: '#246eaa', opacity: '50%' }
              }
              disabled={isDisabledLogin}
            >
              {loader && <LoaderIcon />}
              {!loader && <>Change Password</>}
            </button>
          </div>
        </form>
        <div className='flex justify-center'>
          <div className='pt-6 w-1/2'>
            <p className='pb-3 text-lg font-semibold'>
              If you created your account using Google SSO, please click the
              button below to reset your password.
            </p>
            <button
              className='group relative py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
              // style={{ backgroundColor: "#246eaa" }}
              style={{ backgroundColor: '#246eaa' }}
              onClick={handleForgotPassword}
              aria-label='Reset password for Google SSO accounts'
            >
              {loader && <LoaderIcon />}
              {!loader && <>Reset Password</>}
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}
